export const GoogleWorkspaceConnectForm = () => {
  return (
    <div>
      {/*
      TODO: Support OAuth2 flow for Google Workspace
    */}
    </div>
  );
};
